import {useFirstPeriod, useTaxonomies} from "../../hook/useTaxonomyTermViews";
import {useTranslation} from "../../hook/useTranslation";
import {useTaxonomyTermViews} from "../../hook/useRest";
import {useState} from "@wordpress/element";
import {useStyles} from "./Topics.styles";
import {TimeControl} from "@octavius-rocks/ui";

const Topics = () => {

    const styles = useStyles();
    const i18n = useTranslation("dashboard");
    const {
        all_taxonomies,
    } = useTranslation("taxonomy_term_views");

    const firstPeriod = useFirstPeriod();
    const taxonomies = useTaxonomies();

    const minDate = Date.parse(firstPeriod);
    const [from, setFrom] = useState(new Date(minDate));
    const [to, setTo] = useState(new Date());

    const {views, setArgs, args, isLoading, isAtTheEnd} = useTaxonomyTermViews();

    const { taxonomy = "" } = args;

    const overallViews = views.reduce((prev, item) => {
        return prev + parseInt(item.views);
    }, 0);

    views.forEach(item => {
        item.viewsPerPost = Math.round(overallViews / item.term.count);

    });

    const maxViewsPerPost = Math.max(...views.map(item => item.viewsPerPost));

    return <div className={styles.root}>
        <div className={styles.filters}>
            <div className={styles.filterTime}>
                <TimeControl
                    aggregation="day"
                    value={{
                        start: from,
                        end: to,
                    }}
                    onChange={(value) => {
                        setFrom(value.start);
                        setTo(value.end);
                    }}
                />
            </div>
            <div className={styles.filterTaxonomies}>
                <select
                    value={taxonomy}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value !== taxonomy) {
                            setArgs({...args, taxonomy: e.target.value});
                        }
                    }}>
                    <option>{all_taxonomies}</option>
                    {taxonomies.map((item) => {
                        return <option
                            key={item.name}
                            value={item.name}
                        >{item.label}</option>
                    })}
                </select>
            </div>
        </div>
        {
            isLoading && <div>Loading data ({views.length} terms)...</div>
        }
        <div className={styles.lists}>
            <div className={styles.list} style={{paddingRight: 20,}}>
                <h2>Absolute views</h2>
                <ul>
                    {views.map(item => {
                        const {term, views, url} = item;
                        const {name, taxonomy, slug} = term;
                        const taxonomy_info = taxonomies.find(tax => tax.name === taxonomy);
                        const taxonomy_label = (taxonomy_info) ? taxonomy_info.singular : taxonomy;
                        const key = `${taxonomy}/${slug}`;
                        const percent = (parseInt(views) / overallViews) * 100;
                        return <li key={key} className={styles.listItem}>
                            <div className={styles.listItemDescription}>
                                <span className={styles.taxonomy}>{taxonomy_label} /</span> <a href={url}>{name}</a> <i>{views} views</i>
                            </div>
                            <div className={styles.chartBackground}>
                                <div
                                    className={styles.chartValue}
                                    style={{
                                        width: percent + "%",
                                    }}
                                />
                            </div>
                        </li>;
                    })}
                </ul>
            </div>
            <div className={styles.list} style={{paddingLeft: 20,}}>
                <h2>Views per post</h2>
                <ul>
                    {[...views].sort((a, b) => b.viewsPerPost - a.viewsPerPost).map(item => {
                        const {term, url, viewsPerPost} = item;
                        const {name, taxonomy, slug} = term;
                        const taxonomy_info = taxonomies.find(tax => tax.name === taxonomy);
                        const taxonomy_label = (taxonomy_info) ? taxonomy_info.singular : taxonomy;
                        const key = `${taxonomy}/${slug}`;
                        const percent = (viewsPerPost / maxViewsPerPost) * 100;
                        return <li key={key} className={styles.listItem}>
                            <div className={styles.listItemDescription}>
                                <span className={styles.taxonomy}>{taxonomy_label} /</span> <a href={url}>{name}</a> <i>{viewsPerPost} views per post</i>
                            </div>
                            <div className={styles.chartBackground}>
                                <div
                                    className={styles.chartValue}
                                    style={{
                                        width: percent + "%",
                                    }}
                                />
                            </div>
                        </li>;
                    })}
                </ul>
            </div>

        </div>
    </div>
}

export default Topics;